import PropTypes from "prop-types";
import React, { forwardRef } from "react";

import styled from "styled-components/macro";

import { useCellMeasurements } from "Boards";
import { BOARD_TYPES } from "Boards/const";

import { useBoards } from "./BoardContext";
import { Cell, FooterCell, TitleCellWrapper } from "./Cells";
import Filters from "./Filters";
import { TableBody } from "./TableBody";

const FooterRow = forwardRef(({ shouldHideTotalColumn }, forwardedRef) => {
  const [{ rowTotals, columns, boardType }] = useBoards();

  const isSignupBoard = boardType === BOARD_TYPES.SIGNUP;

  const { width: nameColWidth } = useCellMeasurements({
    columnID: "names",
  });
  const { width: totalColWidth } = useCellMeasurements({
    columnID: "totals",
  });

  return (
    <Wrapper>
      {isSignupBoard ? (
        <FiltersHolder style={{ width: nameColWidth }}>
          <Filters setIsFiltering={() => {}} />
        </FiltersHolder>
      ) : (
        <Filler style={{ width: nameColWidth }} />
      )}

      <ScrollableInside ref={forwardedRef}>
        {
          // Loop over the headers in each row
          columns.map((column, index) => {
            if (index === 0) return null; // member name column

            return (
              <FooterCell
                key={column.ID}
                columnID={column.ID}
                columnType={column.typeDictID}
                total={rowTotals[column.accessor]}
              />
            );
          })
        }
        {!shouldHideTotalColumn && (
          <>
            <SpacerCell />
            <TitleCellWrapper style={{ width: totalColWidth }} />
          </>
        )}
      </ScrollableInside>
    </Wrapper>
  );
});

export default FooterRow;

FooterRow.propTypes = {
  shouldHideTotalColumn: PropTypes.bool,
};

const Wrapper = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  position: sticky;
  bottom: 4px;
  z-index: 100;
  background: #384a5d;
  color: #eceff0;
  margin-top: 2px;
  margin-right: 8px;
  margin-left: 8px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 3px;
  transition: margin-right 0.4s;

  ${TableBody}.filters_open & {
    margin-right: 329px;
  }
`;

const SpacerCell = styled(Cell)`
  height: 1px;
  border-bottom: none;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
`;

const ScrollableInside = styled.div`
  display: flex;
  overflow: auto;
  flex-grow: 1;
  scrollbar-width: none;
  position: relative;
  z-index: 1;
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Filler = styled(Cell)`
  height: 32px;
  // width: 204px;
  width: 182px;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0;
  font-size: 14px;
  position: relative;
  border-bottom: none;
  z-index: 2;

  &::after {
    content: "";
    width: 20px;
    top: 0px;
    bottom: 0px;
    position: absolute;
    left: 100%;
    background-image: linear-gradient(
      to right,
      rgb(56, 74, 93),
      rgba(56, 74, 93, 0)
    );
  }

  @media (max-width: 600px) {
    width: 144px;
  }
`;

const FiltersHolder = styled(Cell)`
  height: 32px;
  border-bottom: none;
  font-weight: 400;
  text-align: center;
  justify-content: center;
  /* width: 204px; */
  width: 182px;
  flex-grow: 0;
  flex-shrink: 0;
  font-weight: 300;
  justify-content: flex-start;
  padding: 4px;
  font-size: 14px;
  position: relative;
  z-index: 2;

  &::after {
    content: "";
    width: 20px;
    top: 0px;
    bottom: 0px;
    position: absolute;
    left: 100%;
    background-image: linear-gradient(
      to right,
      rgb(56, 74, 93),
      rgba(56, 74, 93, 0)
    );
  }

  @media (max-width: 600px) {
    width: 144px;
  }
`;
